export enum EightWingsTabEnum {
  InfoTab = 0,
  ServiceableTab = 1,
  UnserviceableTab = 2,
}
export enum EightWingsStatus {
  Cancel = 0,
  Open = 1,
  Reject = 2,
  InProgress = 3,
  PlannedToDelivery = 4,
  WaitingTTVerify = 5,
  TTVerified = 6,
  SentToPbh = 7,
  ServiceableDelivered = 8,
}

export const EightWingsStatusArray = [
  { Value: EightWingsStatus.Cancel, Description: "Cancel" },
  { Value: EightWingsStatus.Open, Description: "Open", isTab: true },
  { Value: EightWingsStatus.InProgress, Description: "In Progress", isTab: true },
  { Value: EightWingsStatus.PlannedToDelivery, Description: "Planned To Delivery", isTab: true },
  { Value: EightWingsStatus.Reject, Description: "Reject" },
  { Value: EightWingsStatus.TTVerified, Description: "TT Verified" },
  { Value: EightWingsStatus.WaitingTTVerify, Description: "Waiting TT Verify", isTab: true },
  { Value: EightWingsStatus.SentToPbh, Description: "Sent To Pbh" },
  { Value: EightWingsStatus.ServiceableDelivered, Description: "Serviceable Delivered" },
];

export const EightWingsTabs = [...EightWingsStatusArray.filter(x => x.isTab === true)];

export enum EightWingsFeedStorageStatus {
  Open = 1,
  InProgress = 2,
  Accepted = 3,
  Rejected = 4,
}
export const EightWingsFeedStorageStatusArray = [
  { Value: EightWingsFeedStorageStatus.Open, Description: "New Record" },
  { Value: EightWingsFeedStorageStatus.InProgress, Description: "In Progress" },
  { Value: EightWingsFeedStorageStatus.Accepted, Description: "Accepted" },
  { Value: EightWingsFeedStorageStatus.Rejected, Description: "Rejected" },
];
